import type recipeFlow from './flow/recipeFlow';

export const recipeQueryKeys = {
    byExternalId: (externalId: string) => ['recipe', externalId],
    byExternalIds: (externalIds: string[]) => ['recipe', ...externalIds],
    comments: (externalId: string) => ['recipe', 'comments', externalId],
    categories: (externalId: string) => ['recipe', 'categories', externalId],
    recipeAd: (externalId: string) => ['recipe', 'ad', externalId],
    recipeAdContent: (contentId: string) => ['recipe', 'adpage', contentId],
};

export const gastrofyQueryKeys = {
    byExternalId: (externalId: string, storeId: string) => ['gastrofyRecipe', externalId, storeId],
    byRequest: (request: Parameters<typeof recipeFlow.discoverNorthforkRecipes>[0]) => [
        'gastrofyRecipe',
        request,
    ],
};

export const savedFavoriteRecipeKey = ['savedFavoriteRecipes'];
